class CategoryDTO {

    constructor(categoryData){
        if(!categoryData || Object.keys(categoryData).length === 0)
            return

        const {_id, name, provider} = categoryData

        this._id = _id
        this.name = name

        this.provider = provider
    }
}

export default CategoryDTO